// extracted by mini-css-extract-plugin
module.exports = {"content":"loc-module--content--fr2mE","container":"loc-module--container--2splH","locImage":"loc-module--locImage--3-u4M"};